<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import AlertSolid from '../../../../assets/svg/ico-alert-solid.svg';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import Badge from '../../../../assets/svg/ico-badge.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import CalendarRegular from '../../../../assets/svg/ico-calendar-regular.svg';
    import CalendarTest from '../../../../assets/svg/ico-calendar-test.svg';
    import Certification from '../../../../assets/svg/ico-certification.svg';
    import CheckList from '../../../../assets/svg/ico-check-list.svg';
    import CheckSolid from '../../../../assets/svg/ico-check-solid.svg';
    import ChevronDown from '../../../../assets/svg/ico-chevron-down.svg';
    import ChevronRight from '../../../../assets/svg/ico-chevron-right.svg';
    import Circle1Regular from '../../../../assets/svg/ico-circle-1-regular.svg';
    import Circle2Regular from '../../../../assets/svg/ico-circle-2-regular.svg';
    import Circle3Regular from '../../../../assets/svg/ico-circle-3-regular.svg';
    import Circle4Regular from '../../../../assets/svg/ico-circle-4-regular.svg';
    import Circle5Regular from '../../../../assets/svg/ico-circle-5-regular.svg';
    import Circle6Regular from '../../../../assets/svg/ico-circle-6-regular.svg';
    import CircleInfoSolid from '../../../../assets/svg/ico-circle-info-solid.svg';
    import CircleQuestionSolid from '../../../../assets/svg/ico-circle-question-solid.svg';
    import ClockLight from '../../../../assets/svg/ico-clock-light.svg';
    import Cursor from '../../../../assets/svg/ico-cursor.svg';
    import DblArrowL from '../../../../assets/svg/ico-dbl-arrow-l.svg';
    import DblArrowR from '../../../../assets/svg/ico-dbl-arrow-r.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import DoubleArrow from '../../../../assets/svg/ico-double-arrow.svg';
    import Experts from '../../../../assets/svg/ico-experts.svg';
    import EyeSlashSolid from '../../../../assets/svg/ico-eye-slash-solid.svg';
    import EyeSolid from '../../../../assets/svg/ico-eye-solid.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import Feather from '../../../../assets/svg/ico-feather.svg';
    import Fees from '../../../../assets/svg/ico-fees.svg';
    import HandRegular from '../../../../assets/svg/ico-hand-regular.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import Headphones from '../../../../assets/svg/ico-headphones.svg';
    import HeadsetLight from '../../../../assets/svg/ico-headset-light.svg';
    import Ingredient from '../../../../assets/svg/ico-ingredient.svg';
    import Instagram from '../../../../assets/svg/ico-instagram.svg';
    import KLetter from '../../../../assets/svg/ico-k-letter.svg';
    import LeafRegular from '../../../../assets/svg/ico-leaf-regular.svg';
    import Lightbulb from '../../../../assets/svg/ico-lightbulb.svg';
    import Linkedin from '../../../../assets/svg/ico-linkedin.svg';
    import LocationDotRegular from '../../../../assets/svg/ico-location-dot-regular.svg';
    import LocationDotSolid from '../../../../assets/svg/ico-location-dot-solid.svg';
    import Location from '../../../../assets/svg/ico-location.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import LogoGuides from '../../../../assets/svg/ico-logo-guides.svg';
    import MagnifyingGlass from '../../../../assets/svg/ico-magnifying-glass.svg';
    import MemoCircleInfoLight from '../../../../assets/svg/ico-memo-circle-info-light.svg';
    import MinusSolid from '../../../../assets/svg/ico-minus-solid.svg';
    import Mouse from '../../../../assets/svg/ico-mouse.svg';
    import OkLogo from '../../../../assets/svg/ico-ok-logo.svg';
    import Pinterest from '../../../../assets/svg/ico-pinterest.svg';
    import Plant from '../../../../assets/svg/ico-plant.svg';
    import PlaySolid from '../../../../assets/svg/ico-play-solid.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import PlusSolid from '../../../../assets/svg/ico-plus-solid.svg';
    import Policy from '../../../../assets/svg/ico-policy.svg';
    import Portal from '../../../../assets/svg/ico-portal.svg';
    import PotFoodLight from '../../../../assets/svg/ico-pot-food-light.svg';
    import PrintSolid from '../../../../assets/svg/ico-print-solid.svg';
    import Privacy from '../../../../assets/svg/ico-privacy.svg';
    import Process from '../../../../assets/svg/ico-process.svg';
    import QuestionSolid from '../../../../assets/svg/ico-question-solid.svg';
    import Quote from '../../../../assets/svg/ico-quote.svg';
    import Quotes from '../../../../assets/svg/ico-quotes.svg';
    import RoudMap from '../../../../assets/svg/ico-roud-map.svg';
    import SealQuestion from '../../../../assets/svg/ico-seal-question.svg';
    import Security from '../../../../assets/svg/ico-security.svg';
    import Settings from '../../../../assets/svg/ico-settings.svg';
    import ShareNodesRegular from '../../../../assets/svg/ico-share-nodes-regular.svg';
    import SlidersRegular from '../../../../assets/svg/ico-sliders-regular.svg';
    import SortDown from '../../../../assets/svg/ico-sort-down.svg';
    import SortUp from '../../../../assets/svg/ico-sort-up.svg';
    import SpeakerPhone from '../../../../assets/svg/ico-speaker-phone.svg';
    import Spinner from '../../../../assets/svg/ico-spinner.svg';
    import Team from '../../../../assets/svg/ico-team.svg';
    import Tutor from '../../../../assets/svg/ico-tutor.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import UpRightFromSquareSolid from '../../../../assets/svg/ico-up-right-from-square-solid.svg';
    import UserRegular from '../../../../assets/svg/ico-user-regular.svg';
    import UserSolid from '../../../../assets/svg/ico-user-solid.svg';
    import UserVisor from '../../../../assets/svg/ico-user-visor.svg';
    import User from '../../../../assets/svg/ico-user.svg';
    import UtensilsRegular from '../../../../assets/svg/ico-utensils-regular.svg';
    import Xmark from '../../../../assets/svg/ico-xmark.svg';
    import Youtube from '../../../../assets/svg/ico-youtube.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            AlertSolid,
            ArrowDown,
            ArrowLeft,
            ArrowRight,
            ArrowUp,
            Badge,
            Bookmark,
            CalendarRegular,
            CalendarTest,
            Certification,
            CheckList,
            CheckSolid,
            ChevronDown,
            ChevronRight,
            Circle1Regular,
            Circle2Regular,
            Circle3Regular,
            Circle4Regular,
            Circle5Regular,
            Circle6Regular,
            CircleInfoSolid,
            CircleQuestionSolid,
            ClockLight,
            Cursor,
            DblArrowL,
            DblArrowR,
            Dog,
            DoubleArrow,
            Experts,
            EyeSlashSolid,
            EyeSolid,
            Facebook,
            Feather,
            Fees,
            HandRegular,
            Happy,
            Headphones,
            HeadsetLight,
            Ingredient,
            Instagram,
            KLetter,
            LeafRegular,
            Lightbulb,
            Linkedin,
            LocationDotRegular,
            LocationDotSolid,
            Location,
            Lock,
            LogoGuides,
            MagnifyingGlass,
            MemoCircleInfoLight,
            MinusSolid,
            Mouse,
            OkLogo,
            Pinterest,
            Plant,
            PlaySolid,
            PlusCircle,
            PlusSolid,
            Policy,
            Portal,
            PotFoodLight,
            PrintSolid,
            Privacy,
            Process,
            QuestionSolid,
            Quote,
            Quotes,
            RoudMap,
            SealQuestion,
            Security,
            Settings,
            ShareNodesRegular,
            SlidersRegular,
            SortDown,
            SortUp,
            SpeakerPhone,
            Spinner,
            Team,
            Tutor,
            Twitter,
            UpRightFromSquareSolid,
            UserRegular,
            UserSolid,
            UserVisor,
            User,
            UtensilsRegular,
            Xmark,
            Youtube,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
